

































import { PropType } from 'vue';
import { computed, defineComponent, nextTick, watch, ref, toRefs } from '@vue/composition-api';
import { AdgroupConfig, AdgroupFormData, AreaItem, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';
import { intersection } from 'lodash-es';
import { trackEvent } from './../../../utils/index';
import Location from './index';
import { useStdAdgroupIs } from '@tt4b/ttam-hooks';

const name = 'ttam-location-compose-flex';
export default defineComponent({
  name,
  components: {
    TtamLocation: Location.TtamLocation,
    TtamLocationTips: Location.TtamLocationTips,
  },
  props: {
    selectedList: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    locationData: {
      type: Array as PropType<AreaItem[]>,
      default: () => [{ value: 'no locations available' }],
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
    // 自定义过滤函数用于过滤可选的国家
    // eslint-disable-next-line vue/require-default-prop
    filterMethod: {
      type: Function,
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig, createMode, selectedList, locationData } = toRefs(props);
    const { locationValidator } = Location.useRules({ adgroupData });
    const helpHref = ref('/help/article?aid=6669234451085524998');
    const particleLocations = ref();
    const _particleLocations = computed({
      get: () => selectedList.value,
      set: val => {
        emit('input', val);

        nextTick(() => {
          particleLocations.value?.validate?.('custom');
        });
      },
    });

    const { offlineAreaTipsVisible } = Location.usePropsOfflineAreaTipsVisible({
      adgroupData,
      createMode,
    });

    const { DSALoading, DSAInfo, openDSAClick } = Location.useDSA();
    const { japanVideoTipsVisible } = Location.usePropsJapanVideoTipsVisible({ adgroupData, campaignData });
    const { dsaTipsVisible } = Location.usePropsDSATipsVisible({ adgroupData, DSAInfo });

    const { treeProps } = Location.useTreeProps();
    const { isSupportBrandSafety } = Location.usePropsSupportBrandSafety({ adgroupData });
    const { disabledLocation } = Location.usePropsDisabledLocation({ adgroupData, adgroupConfig });

    /** 处理虚拟节点 */
    const onLocationChange = (val: number[] = [], nodes: AreaItem[], node: AreaItem, isChecked: boolean) => {
      const allNodes = {};
      nodes.forEach(item => {
        allNodes[item.id] = item;
      });
      emit('location-change', val, allNodes);
    };

    const iconHoverTrack = () => trackEvent('create_adgroup_location_tips_hover');

    const clearAllTrack = () => {
      _particleLocations.value = [];
      trackEvent('create_adgroup_location_clear_all');
    };

    const { isCLA } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    return {
      name,
      locationValidator,
      helpHref,
      _particleLocations,
      particleLocations,
      offlineAreaTipsVisible,
      DSALoading,
      japanVideoTipsVisible,
      dsaTipsVisible,
      isSupportBrandSafety,
      disabledLocation,
      treeData: locationData,
      treeProps,
      automatedTargeting: computed(() => adgroupData.value?.automatedTargeting),
      adgroupId: computed(() => adgroupData.value?.adId || ''),
      openDSAClick,
      onLocationChange,
      iconHoverTrack,
      clearAllTrack,
      isCLA,
    };
  },
});
